import { render, staticRenderFns } from "./TaxService.vue?vue&type=template&id=22b91170&scoped=true&"
import script from "./TaxService.vue?vue&type=script&lang=js&"
export * from "./TaxService.vue?vue&type=script&lang=js&"
import style0 from "./TaxService.vue?vue&type=style&index=0&id=22b91170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b91170",
  null
  
)

export default component.exports